export default __webpack_public_path__ + "static/media/mobGreyStone.13981f66.png";